import { toRefs, reactive } from "vue";

import axios from "axios";
import config from "../../config"




const state = reactive({
    initialized: false,
    initializing: false,
});


if (!state.initialized && !state.initializing) {
    state.initializing = true;
    state.initialized = true
    state.initializing = false
}

function reset() {
    state.error = null
    state.customerId = null
    state.customer = null
    state.registrationRequest = null


}


async function createInvoiceFromOrder(order, data) {
    if(!order ||!order.id){
        console.error('@invoiceService@createInvoiceFromOrder: no order with id', order)
        return null
    }
    
    if(!data){data = {}}
    data = JSON.parse(JSON.stringify(data))

    try {
        let response = await axios.post(config.apiUrl + "/api/frontend/invoices/create-from-order", {orderId: order.id,  ...data});
        if (response && response.data) {
            return response.data
        }
    } catch (error) {
        console.error('@invoiceService@createInvoiceFromOrder: ', error)
    }
    return null
}



export default {
    ...toRefs(state),
    createInvoiceFromOrder
}

